import { getFileUrl as _getFileUrl } from '@shared/utils/file-url';

export function getFileUrl(file: { id: number; key: string }): string {
  return _getFileUrl(
    file,
    import.meta.env.VITE_IMAGES_URL as string | undefined,
    import.meta.env.VITE_URL_API as string | undefined,
  );
}
